import { palette } from '../global/palette';
import { outlinedInputClasses } from '@mui/material';
import type { ComponentOverride } from '../types';

export const MuiOutlinedInput: ComponentOverride<'MuiOutlinedInput'> = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        [`&:hover`]: {
          [`.${outlinedInputClasses.notchedOutline}`]: {
            borderColor: palette.common.black,
          },
        },
        [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: palette.grey[400],
        },
        [`&.${outlinedInputClasses.focused}`]: {
          [`.${outlinedInputClasses.notchedOutline}`]: {
            borderColor: palette.primary.main,
            borderWidth: 2,
          },
        },
        [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: palette.error.main,
        },
      },
      notchedOutline: {
        borderColor: palette.grey[600],
        '&>legend': {
          fontSize: 13,
        },
      },
      input: {
        padding: '12px 16px',
      },
      sizeSmall: {
        [`& > .${outlinedInputClasses.input}`]: {
          padding: '9px 16px',
        },
      },
      multiline: {
        padding: 0,
      },
    },
  },
};
